<div class="wide admin-panel-announcement-history">
  <p-table
    #table
    (onSort)="onPrimeSortChange($event)"
    [lazy]="true"
    [loading]="isDataLoading()"
    [rows]="tablePage()?.size || 10"
    [scrollable]="true"
    scrollHeight="flex"
    [tableStyle]="{ 'min-width': '60rem' }"
    [totalRecords]="tablePage()?.totalElements || 0"
    [value]="rows()"
    dataKey="id"
    class="customPrimeTable"
  >
    <ng-template #header>
      <tr class="filters-row">
        <th pSortableColumn="dataZdarzenia">
          <div class="flex items-center gap-2">
            Data
            <p-sortIcon field="dataZdarzenia" />
          </div>
        </th>
        <th pSortableColumn="typPodmiotu">
          <div class="flex items-center gap-2">
            Obiekt
            <p-sortIcon field="typPodmiotu" />
          </div>
        </th>
        <th pSortableColumn="typZdarzenia.kodZdarzenia">
          <div class="flex items-center gap-2">
            Rodzaj
            <p-sortIcon field="typZdarzenia.kodZdarzenia" />
          </div>
        </th>
        <th pSortableColumn="idWykonawcy">
          <div class="flex items-center gap-2">
            Autor
            <p-sortIcon field="idWykonawcy" />
          </div>
        </th>
        <th alignFrozen="right" pFrozenColumn>Akcje</th>
      </tr>
      <tr>
        <td class="table-filter-cell">
          <p-date-picker
            (onClear)="onPrimeFilterChange($event, 'eventDate')"
            (onSelect)="onPrimeFilterChange($event, 'eventDate')"
            [readonlyInput]="true"
            [showClear]="true"
            [(ngModel)]="tableFilters.eventDate"
            appendTo="body"
            class="w-full"
            dateFormat="dd-mm-yy"
            ariaLabel="Filtruj po dacie"
          />
        </td>
        <td class="table-filter-cell">
          <p-select
            (onChange)="onPrimeFilterChange($event.value, 'eventObject')"
            [options]="eventObjectOptions"
            [showClear]="true"
            [(ngModel)]="tableFilters.eventObject"
            optionLabel="label"
            optionValue="value"
            placeholder="Wybierz obiekt"
            appendTo="body"
            class="w-full"
            ariaLabel="Filtruj po obiekcie"
          ></p-select>
        </td>
        <td class="table-filter-cell">
          <p-select
            (onChange)="onPrimeFilterChange($event.value, 'eventType')"
            [options]="eventTypeOptions"
            [showClear]="true"
            [(ngModel)]="tableFilters.eventType"
            optionLabel="label"
            optionValue="value"
            placeholder="Wybierz rodzaj"
            appendTo="body"
            class="w-full"
            ariaLabel="Filtruj po rodzaju"
          ></p-select>
        </td>
        <td class="table-filter-cell">
          <input
            (change)="onPrimeFilterChange($event.target, 'eventAuthor')"
            aria-label="Filtruj po autorze"
            pInputText
          />
        </td>
        <td alignFrozen="right" pFrozenColumn></td>
      </tr>
    </ng-template>
    <ng-template #body let-row>
      <tr>
        <td>{{ row.eventDate | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
        <td>{{ row.eventObject | constLabelReader: USER_EVENT_OBJECT }}</td>
        <td>{{ row.eventType | userEventBusinessLabel }}</td>
        <td>{{ row.eventAuthor }}</td>
        <td class="min-w-[160px]">
          <p-button
            type="button"
            icon="pi pi-eye"
            [text]="true"
            [rounded]="true"
            ariaLabel="Zobacz szczegóły"
            class="customShowMoreButton"
            pTooltip="Zobacz szczegóły"
            tooltipPosition="top"
            (click)="showDetails(row)"
          />
        </td>
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td colspan="5">Brak danych</td>
      </tr>
    </ng-template>
  </p-table>

  <div class="table-footer">
    <div class="table-pagination">
      <p-paginator
        (onPageChange)="onPrimePageChange($event)"
        [rowsPerPageOptions]="[10, 25, 50]"
        [rows]="tablePage()?.size || 10"
        [totalRecords]="tablePage()?.totalElements || 0"
        pageLinkSize="3"
        class="customPrimePaginator"
      />
      <div class="table-meta">
        Strona {{ (tablePage()?.number || 0) + 1 }} z
        {{ tablePage()?.totalPages || 0 }}
      </div>
    </div>
  </div>
</div>

<div class="narrow admin-panel-announcements">
  <p-card class="mb-4">
    <div class="flex flex-col gap-4">
      <div class="flex flex-col gap-2">
        <span class="font-bold" id="eventDateMobileLabel">Data</span>
        <p-date-picker
          ariaLabelledBy="eventDateMobileLabel"
          (onClear)="onPrimeFilterChange($event, 'eventDate')"
          (onSelect)="onPrimeFilterChange($event, 'eventDate')"
          [readonlyInput]="true"
          [showClear]="true"
          [(ngModel)]="tableFilters.eventDate"
          appendTo="body"
          class="w-full"
          dateFormat="dd-mm-yy"
        />
      </div>
      <div class="flex flex-col gap-2">
        <span class="font-bold" id="eventObjectMobileLabel">Obiekt</span>
        <p-select
          ariaLabelledBy="eventObjectMobileLabel"
          (onChange)="onPrimeFilterChange($event.value, 'eventObject')"
          [options]="eventObjectOptions"
          [showClear]="true"
          [(ngModel)]="tableFilters.eventObject"
          optionLabel="label"
          optionValue="value"
          placeholder="Wybierz obiekt"
          appendTo="body"
          class="w-full"
        ></p-select>
      </div>
      <div class="flex flex-col gap-2">
        <span class="font-bold" id="eventTypeMobileLabel">Rodzaj</span>
        <p-select
          ariaLabelledBy="eventTypeMobileLabel"
          (onChange)="onPrimeFilterChange($event.value, 'eventType')"
          [options]="eventTypeOptions"
          [showClear]="true"
          [(ngModel)]="tableFilters.eventType"
          optionLabel="label"
          optionValue="value"
          placeholder="Wybierz rodzaj"
          appendTo="body"
          class="w-full"
        ></p-select>
      </div>
      <div class="flex flex-col gap-2">
        <span class="font-bold" id="eventAuthorMobileLabel">Autor</span>
        <input
          aria-labelledby="eventAuthorMobileLabel"
          (input)="onFilterChangeMobile($event.target, 'eventAuthor')"
          pInputText
          class="w-full"
          [(ngModel)]="tableFilters.eventAuthor"
        />
      </div>
      <div class="flex justify-end">
        <p-button
          type="button"
          label="Wyczyść filtry"
          styleClass="customInfoButton outlined"
          (click)="clearFilters()"
        />
      </div>
    </div>
  </p-card>

  <div class="flex flex-col gap-6">
    @for (row of rows(); track row.id) {
      <p-card>
        <div class="flex flex-col gap-2">
          <div>
            <span class="font-bold">Data</span>
            <div>{{ row.eventDate | date: 'yyyy-MM-dd HH:mm:ss' }}</div>
          </div>
          <div>
            <span class="font-bold">Obiekt</span>
            <div>{{ row.eventObject | constLabelReader: USER_EVENT_OBJECT }}</div>
          </div>
          <div>
            <span class="font-bold">Rodzaj</span>
            <div>{{ row.eventType | userEventBusinessLabel }}</div>
          </div>
          <div>
            <span class="font-bold">Autor</span>
            <div>{{ row.eventAuthor }}</div>
          </div>
          <div class="flex justify-end mt-2">
            <p-button
              type="button"
              icon="pi pi-eye"
              [text]="true"
              [rounded]="true"
              ariaLabel="Zobacz szczegóły"
              class="customShowMoreButton"
              pTooltip="Zobacz szczegóły"
              tooltipPosition="top"
              (click)="showDetails(row)"
            />
          </div>
        </div>
      </p-card>
    }

    <div class="table-pagination">
      <p-paginator
        (onPageChange)="onPrimePageChange($event)"
        [rowsPerPageOptions]="[10, 25, 50]"
        [rows]="tablePage()?.size || 10"
        [totalRecords]="tablePage()?.totalElements || 0"
        pageLinkSize="3"
        class="customPrimePaginator"
      />
      <div class="table-meta">
        Strona {{ (tablePage()?.number || 0) + 1 }} z
        {{ tablePage()?.totalPages || 0 }}
      </div>
    </div>
  </div>
</div>
